import {command, queryAll, queryOne, querySearch} from "../utils/api";

const GET_DISCOUNT_REASONS_URL = `${process.env.PUBLIC_URL}/api/v1/r/discountReasons`;
export const GET_DISCOUNT_REASONS = 'GET_DISCOUNT_REASONS';
export const GET_DISCOUNT_REASONS_COMPLETED = 'GET_DISCOUNT_REASONS_COMPLETED';
export const GET_DISCOUNT_REASONS_FAILED = 'GET_DISCOUNT_REASONS_FAILED';
export function getDiscountReasons() {
  const queryFilter = {
    order: "name ASC"
  };
  return queryAll(GET_DISCOUNT_REASONS_URL, queryFilter, GET_DISCOUNT_REASONS, GET_DISCOUNT_REASONS_COMPLETED, GET_DISCOUNT_REASONS_FAILED);
}

export const SEARCH_DISCOUNT_REASONS = 'SEARCH_DISCOUNT_REASONS';
export const SEARCH_DISCOUNT_REASONS_COMPLETED = 'SEARCH_DISCOUNT_REASONS_COMPLETED';
export const SEARCH_DISCOUNT_REASONS_FAILED = 'SEARCH_DISCOUNT_REASONS_FAILED';
export const searchDiscountReasons = querySearch(GET_DISCOUNT_REASONS_URL, SEARCH_DISCOUNT_REASONS, SEARCH_DISCOUNT_REASONS_COMPLETED, SEARCH_DISCOUNT_REASONS_FAILED,
  ['name']);

export const GET_DISCOUNT_REASON = 'GET_DISCOUNT_REASON';
export const GET_DISCOUNT_REASON_COMPLETED = 'GET_DISCOUNT_REASON_COMPLETED';
export const GET_DISCOUNT_REASON_FAILED = 'GET_DISCOUNT_REASON_FAILED';
export function getDiscountReason({discountReasonId}) {
  return queryOne(GET_DISCOUNT_REASONS_URL, {where: {discountReasonId}}, GET_DISCOUNT_REASON, GET_DISCOUNT_REASON_COMPLETED, GET_DISCOUNT_REASON_FAILED);
}

const DISCOUNT_REASON_ACTION_URL = `${process.env.PUBLIC_URL}/api/v1/discountReason`;
export const ADD_DISCOUNT_REASON = 'ADD_DISCOUNT_REASON';
export const ADD_DISCOUNT_REASON_COMPLETED = 'ADD_DISCOUNT_REASON_COMPLETED';
export const ADD_DISCOUNT_REASON_FAILED = 'ADD_DISCOUNT_REASON_FAILED';
export const addDiscountReason = command(DISCOUNT_REASON_ACTION_URL + '/addDiscountReason', ADD_DISCOUNT_REASON, ADD_DISCOUNT_REASON_COMPLETED, ADD_DISCOUNT_REASON_FAILED);

export const UPDATE_DISCOUNT_REASON = 'UPDATE_DISCOUNT_REASON';
export const UPDATE_DISCOUNT_REASON_COMPLETED = 'UPDATE_DISCOUNT_REASON_COMPLETED';
export const UPDATE_DISCOUNT_REASON_FAILED = 'UPDATE_DISCOUNT_REASON_FAILED';
export const updateDiscountReason = command(DISCOUNT_REASON_ACTION_URL + '/updateDiscountReason', UPDATE_DISCOUNT_REASON, UPDATE_DISCOUNT_REASON_COMPLETED,
  UPDATE_DISCOUNT_REASON_FAILED);

export const UPDATE_DISCOUNT_REASON_VISIBILITY = 'UPDATE_DISCOUNT_REASON_VISIBILITY';
export const UPDATE_DISCOUNT_REASON_VISIBILITY_COMPLETED = 'UPDATE_DISCOUNT_REASON_VISIBILITY_COMPLETED';
export const UPDATE_DISCOUNT_REASON_VISIBILITY_FAILED = 'UPDATE_DISCOUNT_REASON_VISIBILITY_FAILED';
export const updateDiscountReasonVisibility = command(DISCOUNT_REASON_ACTION_URL + '/updateDiscountReasonVisibility', UPDATE_DISCOUNT_REASON_VISIBILITY,
  UPDATE_DISCOUNT_REASON_VISIBILITY_COMPLETED, UPDATE_DISCOUNT_REASON_VISIBILITY_FAILED);

// export const DELETE_DISCOUNT_REASON = 'DELETE_DISCOUNT_REASON';
// export const DELETE_DISCOUNT_REASON_COMPLETED = 'DELETE_DISCOUNT_REASON_COMPLETED';
// export const DELETE_DISCOUNT_REASON_FAILED = 'DELETE_DISCOUNT_REASON_FAILED';
// export const deleteDiscountReason = command(
//   DISCOUNT_REASON_ACTION_URL + '/deleteDiscountReason',
//   DELETE_DISCOUNT_REASON,
//   DELETE_DISCOUNT_REASON_COMPLETED,
//   DELETE_DISCOUNT_REASON_FAILED
// );
//
// export const SHOW_DELETE_DISCOUNT_REASON_MODAL = 'SHOW_DELETE_DISCOUNT_REASON_MODAL';
// export function showDeleteDiscountReasonModal(discountReason) {
//   return {type: SHOW_DELETE_DISCOUNT_REASON_MODAL, payload: discountReason};
// }
//
// export const HIDE_DELETE_DISCOUNT_REASON_MODAL = 'HIDE_DELETE_DISCOUNT_REASON_MODAL';
// export function hideDeleteDiscountReasonModal() {
//   return {type: HIDE_DELETE_DISCOUNT_REASON_MODAL};
// }


// WEBPACK FOOTER //
// ./src/DiscountReason/actions.js